import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Switch,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Button, Input } from "../../../../shared/ReusableComponents";
import { DateTimeInput } from "../../../../shared/ReusableComponents/DateTimeInput";
import { isMoment } from "moment";
import {
  DateFormatter,
  DateTimeFormats,
} from "../../../../shared/utils/DateFormatter";
interface Field {
  label: string;
  key: string;
  type?: any;
  options?: { label: string; value: string }[];
  readonly?: boolean;
}

interface ITelephoneOrdersDailogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  fields: Field[];
  additionalContent?: React.ReactNode;
  caption: string;
  errors?: Record<string, string>;
}

const NurseInitiateDialog: React.FC<ITelephoneOrdersDailogProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  formData,
  setFormData,
  fields,
  caption,
  errors,
}) => {
  const initialErrors: Record<string, string> = {
    common: "",
  };
  const [error, setError] = useState<typeof initialErrors>(initialErrors);
  const clearErrors = () => {
    setError(initialErrors);
  };

  const handleSubmit = () => {
    let allFieldFilled = true;
    let newErrors: Record<string, string> = { ...initialErrors };

    fields.forEach((field) => {
      if (field.key !== "initiator") {
        const value = formData[field.key];

        if (!value) {
          allFieldFilled = false;
        } else {
          newErrors[field.key] = "";
        }
      }
    });

    if (!allFieldFilled) {
      newErrors.common = "All the fields are mandatory, Please check.";
    }

    setError(newErrors);

    const hasErrors = Object.values(newErrors).some((msg) => msg.length > 0);
    if (hasErrors) {
      return;
    }
    if (allFieldFilled) {
      onSubmit();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    let value: any = null;
    //if date time type

    switch (field) {
      case "dateOfDose":
      case "timeOfDose":
        if (isMoment(e)) {
          value =
            field === "dateOfDose"
              ? DateFormatter.formatDate(e.toISOString())
              : DateFormatter.formatLocalToUtcDateTime(
                  e.toISOString(),
                  DateTimeFormats.TimeFormat
                );
        }
        break;
      default:
        value = e.target.value;
        break;
    }
    // if (value?.includes("-")) {
    //   return; // Reject input if it contains a hyphen
    // }
    setFormData((prevState: any) => ({ ...prevState, [field]: value }));

    if (value !== "" && error.common) {
      setError((prevError) => ({
        ...prevError,
        common: "",
      }));
    }
  };

  useEffect(() => {
    if (!open) {
      clearErrors();
    }
  }, [open]);

  if (formData.dateOfDose === "Invalid date") {
    formData.dateOfDose = "";
  }

  if (formData.timeOfDose === "Invalid date") {
    formData.timeOfDose = "";
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle className="vital-title">
        {title}
        <span style={{ fontSize: "14px" }}>{caption}</span>
        <IconButton
          edge="end"
          onClick={onClose}
          aria-label="close"
          sx={{
            position: "absolute",
            right: 25,
            top: 8,
            color: "#424242",
          }}
        >
          <GridCloseIcon />
        </IconButton>
        <Box
          sx={{
            borderBottom: "2px solid var(--color-border-model)",
            marginTop: 1.4,
          }}
        />
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", gap: 2, mt: "10px" }}>
          {fields.map((field) =>
            field.key === "initiator" ? (
              <Input
                name=""
                key={field.key}
                label={field.label}
                value={formData[field.key]}
                InputLabelProps={{
                  style: { color: "var(--color-border-model)" },
                }}
                disabled
              />
            ) : field.key === "dateOfDose" || field.key === "timeOfDose" ? (
              <DateTimeInput
                size="small"
                type={field.key === "dateOfDose" ? "date" : "time"}
                name={field.key}
                format={
                  field.key === "dateOfDose"
                    ? DateTimeFormats.DateFormat
                    : DateTimeFormats.TimeFormat
                }
                value={formData[field.key]}
                hasError={error.common && !formData[field.key] ? "\u200B" : ""}
                helperText={
                  error.common && !formData[field.key] ? "" : undefined
                }
                onChange={(e) => handleChange(e, field.key)}
                required
                className={
                  (error.common && !formData[field.key] ? "\u200B" : "") &&
                  "warningStyles"
                }
                label={field.label}
              />
            ) : (
              <Input
                name=""
                key={field.key}
                label={field.label}
                value={formData[field.key]}
                hasError={error.common && !formData[field.key] ? "\u200B" : ""}
                helperText={
                  error.common && !formData[field.key] ? "" : undefined
                }
                onChange={(e) => handleChange(e, field.key)}
                required
              />
            )
          )}
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--color-border-model)",
            marginTop: "21px",
          }}
        >
          <span style={{ color: "var(--color-error-main)" }}>
            {error.common}
          </span>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "0px 22px 15px 0px", columnGap: "10px" }}>
        <Button
          variant="outlined"
          onClick={onClose}
          text="Cancel"
          fullWidth={false}
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          text="Save"
          fullWidth={false}
        />
      </DialogActions>
    </Dialog>
  );
};

export default NurseInitiateDialog;
